import React from 'react';
import caseStudies from '../Data/CaseStudies';
import  './CaseStudies.scss';
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';

export default function Work() {
    return (
        <div>
            <Helmet>
                <meta charSet="utf-8" />
                <meta name="description" content=" Work Case Studies by Miko Gonzaga" />
                <title>Work Case Studies by Miko Gonzaga</title>
            </Helmet>

            <h3>Design</h3>
            <span className="block"></span>

            <div className="work">
                {caseStudies.map(({
                  id,
                  link,
                  title,
                  role,
                  img,
                  cta }) =>
                    <div className="case-study case-card animate fadeIn" key={id}>
                      <Link to={`/case-study/${id}`}>
                        <img src={img.url} alt={img.alt} />
                        <div className={`${id} case-description`}>
                          <h3>{title}</h3>
                          <span>{role}</span>
                          <small>{cta} →</small>
                        </div>
                      </Link>
                    </div>
                )}
            </div>
        </div>
    )
}
